export default __webpack_public_path__ + "static/media/Dexa_Scan.5dd4cfba.png";